export default __webpack_public_path__ + "static/Vol 3 - TA 9 - ALC-0432ffa6f88571ae6020ed3a95cf5e92.pdf";